import { Button, Card } from 'react-bootstrap';
import './style.css';
import AlertMessage from '../../../Alert';
import InputMask from 'react-input-mask';
import { useContext, useState } from 'react';
import api from '../../../../services/api';
import { CadastroContext, Endereco } from '../../../../contexts/CadastroContext';
import { useNavigate } from 'react-router-dom';

const AsoEnderecoEmpresa = () => {
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [cep, setCep] = useState('');
    const [bairro, setBairro] = useState('');
    const [estado, setEstado] = useState('');
    const [cidade, setCidade] = useState('');
    const [rua, setRua] = useState('');
    const [complemento, setComplemento] = useState('');
    const [numero, setNumero] = useState('');
    const [inputsLiberados, setInputsLiberados] = useState(false);
    const [continuar, setContinuar] = useState(true);
    const navigate = useNavigate();

    const handleCep = async (event: any) => {
        try {
            const cepInput = event.target.value.replace(/\D/g, '');
            if (cepInput.length === 8) {
                const response = await api.get(`https://viacep.com.br/ws/${cepInput}/json/`);   
                if (response.data.error === true) {
                    setAlert({ show: true, message: "Erro ao identificar CEP", variant: "error" });
                    return;
                } else {
                    const { logradouro, bairro, localidade, uf } = response.data;
                    setCep(cepInput);
                    setBairro(bairro);
                    setEstado(uf);
                    setCidade(localidade);
                    setRua(logradouro)
                    setInputsLiberados(true);
                    setContinuar(false);
                }
            }
        } catch (error) {
            setAlert({ show: true, message: "Erro ao identificar CEP", variant: "error" });
        }
    }

    const handleEndereco = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setRua(value);
        }
    }

    const handleNumero = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setNumero(value);
        }
    }

    const handleBairro = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setBairro(value);
        }
    }

    const handleComplemento = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setComplemento(value);
        }
    }

    const handleCidade = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setCidade(value);
        }
    }

    const handleEstado = (event: any) => {
        const value = event.target.value;
        if (value && value !== '') {
            setEstado(value);
        }
    }

    const handleVoltar = () => {
        navigate("/aso/registro/cnae");
    }

    const handleContinuar = () => {
        const endereco: Endereco = { cep, bairro, rua, numero, cidade, estado, complemento };
        cadastro.endereco = endereco;
        handleCadastroChange(cadastro);
        navigate('/aso/registro/faturamento-mensal-empresa');
    }
    
    return (
        <>
            <div className='aso-container-end-emp'>
                <div className='aso-titulo-container-end-emp'>
                    <div className="aso-titulo-end-emp">Qual é o endereço da empresa?</div>
                </div>
                <div className='aso-container-card-end-emp'>
                    <Card className='aso-card-end-emp'>
                        <div className='aso-card-content-container-end-emp'>
                            <div className='aso-inputs-row'>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="cep" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>CEP</span>
                                    </label>
                                    <div className='aso-card-content-container-end-emp-input'>
                                        <InputMask
                                            mask="99999-999"
                                            type="text"
                                            pattern="[0-9]*"
                                            id='cep'
                                            placeholder='Insira o CEP'
                                            title='Digite o CEP'
                                            className='aso-card-content-end-emp-input'
                                            onChange={(e: any) => handleCep(e)}/>
                                    </div>
                                    <div className='aso-card-content-end-emp-input-span'>
                                        <span>Insira apenas números, sem traços nem pontos.</span>
                                    </div>
                                </div>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="endereco" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Endereço</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            value={rua}
                                            placeholder='Insira a rua'
                                            onChange={(e: any) => handleEndereco(e)}
                                            id='endereco'
                                            title='Digite o endereço (nome da rua)'
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                            </div>
                            <div className='aso-inputs-row'>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="numero" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Número</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            value={numero}
                                            placeholder='Insira o número'
                                            onChange={(e: any) => handleNumero(e)}
                                            id='numero'
                                            title='Digite o número do edifício'
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="bairro" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Bairro</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            value={bairro}
                                            placeholder='Insira o bairro'
                                            onChange={(e: any) => handleBairro(e)}
                                            id='bairro'
                                            title='Digite o bairro'
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                            </div>
                            <div className='aso-inputs-row'>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="complemento" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Complemento</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            placeholder='Insira o complemento'
                                            value={complemento}
                                            onChange={(e: any) => handleComplemento(e)}
                                            id='complemento'
                                            title='Digite o complemento (opcional)'
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="cidade" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Cidade</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            placeholder='Insira o cidade'
                                            value={cidade}
                                            onChange={(e: any) => handleCidade(e)}
                                            id='cidade'
                                            title='Digite a cidade'
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                            </div>
                            <div className='aso-inputs-row'>
                                <div className='aso-card-content-cep-end-emp'>
                                    <label htmlFor="estado" className='label-container'>
                                        <span className='aso-card-content-end-emp-label-span'>Estado</span>
                                    </label>
                                    <div className={`aso-card-content-container-end-emp-input ${!inputsLiberados ? 'disabled-input' : ''}`}>
                                        <InputMask
                                            type="text"
                                            placeholder='Insira o estado'
                                            value={estado}
                                            onChange={(e: any) => handleEstado(e)}
                                            id='estado'
                                            title='Digite o estado'
                                            disabled={!inputsLiberados}
                                            className={`${!inputsLiberados ? 'aso-card-content-end-emp-input-disabled' : 'aso-card-content-end-emp-input'}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className='aso-button-end-emp-container'>
                        <Button variant="primary" className='aso-button-end-emp-content' onClick={handleVoltar}>
                            Voltar
                        </Button>
                        <Button variant="primary" className='aso-button-end-emp-content' onClick={handleContinuar} disabled={continuar}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default AsoEnderecoEmpresa;